import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { formatBoolean, formatBooleanToYesNo } from 'components/helper/helper';
import { CheckboxContent } from 'screen/summary/components/ItemContent';
import CardConfig from 'components/CardConfig';
import Stack from '@mui/material/Stack';
import { ModalCheckActivitiesFields } from 'screen/activitiesAndHonors/components/ModalCheckMissingFields';
import { USER_ROLE } from 'constants/common';
import CheckboxInput from 'components/input/CheckboxInput';
import { getUserRole } from 'utils/sessionStorage';

const renderFillAppStatus = (item: any) => {
  return (
    <span className="d-flex align-items-center gap-1">
      {item.isIncludeIntoCommonApp && (
        <img
          alt="cm"
          src="/assets/icons/icon-cm.svg"
          style={{ marginTop: '-0.5rem' }}
        />
      )}
      {item.isIncludeIntoUCApp && (
        <img
          alt="uc"
          src="/assets/icons/icon-uc.svg"
          style={{ marginTop: '-0.5rem' }}
        />
      )}
      {item.isIncludeIntoCSUApp && (
        <img
          alt="csu"
          src="./assets/icons/icon-csu-5.svg"
          style={{ marginTop: '-13px' }}
        />
      )}
    </span>
  );
};

const ActivityItem = ({
  activity,
  index,
  expandAll,
  handleExpandActive,
}: {
  activity: any;
  index: string;
  expandAll?: boolean;
  handleExpandActive?: (value: any) => void;
}) => {
  const [labelWhatDoYouDo, setLabelWhatDoYouDo] = React.useState({
    label: 'What did you do? *',
    feedback: '',
  });
  React.useEffect(() => {
    switch (activity?.categoryUC) {
      case 'Educational Preparation Program':
        setLabelWhatDoYouDo({
          label: 'Briefly Describe the Program',
          feedback: `Think about the program's main focus, your experience, and what you accomplished and learned while participating in the program.`,
        });
        break;
      case 'Other Coursework':
        setLabelWhatDoYouDo({
          label: 'Briefly Describe the course *',
          feedback: `What program or school offered the course? Also, think about describing the major themes or topics the course covered, as well as what knowledge or skills you learned.`,
        });
        break;
      case 'Work Experience':
        setLabelWhatDoYouDo({
          label: 'What were your job responsibilities?',
          feedback: ``,
        });
        break;
      default:
        setLabelWhatDoYouDo({
          label: 'What did you do? *',
          feedback: '',
        });
        break;
    }
  }, [activity?.categoryUC, expandAll]);

  return (
    <CardConfig
      expandAll={expandAll}
      handleExpandActive={handleExpandActive}
      headerElement={
        <Stack direction="row" justifyContent="space-between" alignItems="center" className="w-100">
          <span className="flex-grow-1 text-truncate pe-2">
            {[
              activity?.categoryUC,
              activity?.activityExperienceProgramName,
              activity?.positionDescription,
              activity?.categoryUC === 'Work Experience'
                ? activity?.workExperience_whereDidYouWork
                : null,
              activity?.categoryUC === 'Work Experience' ? activity?.workExperience_jobTitle : null,
            ]
              .filter((text) => !!text)
              .join(' - ')}
          </span>
          <Stack direction="row" alignItems="center" spacing={1} className="flex-shrink-0">
            {renderFillAppStatus(activity)}
            <span className="p-1 text-field-light fw-bold">{index}</span>
          </Stack>
        </Stack>
      }
    >
      <Row className="g-3 mb-3">
        <Col md={6} className="px-1">
          <div className="gm-summary-field-label">Category *</div>
          <div className="gm-summary-field-value">{activity?.categoryUC || '-'}</div>
        </Col>
        <Col md={6} className="px-1">
          <div className="gm-summary-field-label">Activity Type</div>
          <div className="gm-summary-field-value">{activity?.activityType || '-'}</div>
        </Col>
      </Row>

      <Row className="d-none g-3 mb-3">
        <Col md={12} className="d-none px-1">
          <div className="gm-summary-field-label">Category *</div>
          <div className="gm-summary-field-value">{activity?.category || '-'}</div>
        </Col>
      </Row>

      {(activity?.activityType === 'Athletics (other)' ||
        activity?.activityType === 'Athletics (JV or varsity)' ||
        activity?.activityType === 'Athletics: Club' ||
        activity?.activityType === 'Athletics: JV/Varsity') && (
          <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Activity type Athetics</div>
              <div className="gm-summary-field-label">Sport/team*</div>
              <div className="gm-summary-field-value">{activity?.sportOrTeam || '-'}</div>
            </Col>
          </Row>
          </>
      )}
      {activity?.categoryUC === 'Extracurricular Activity' && (
        <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Extracurricular Activity</div>
              <div className="gm-summary-field-label">What's the name of the activity?*</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.activityExperienceProgramName || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.activityExperienceProgramName?.length || 0}/60 characters
              </div>
            </Col>
          </Row>
        </>
      )}
      {activity?.categoryUC === 'Other Coursework' && (
          <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Other Coursework</div>
              <div className="gm-summary-field-label">What was the course name?*</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.otherCoursewordName || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.otherCoursewordName?.length || 0}/60 characters
              </div>
            </Col>
          </Row>
          </>
      )}
      {activity?.categoryUC === 'Educational Preparation Program' && (
          <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Educational Preparation Program</div>
              <div className="gm-summary-field-label">What was the program name? *</div>
              <div className="gm-summary-field-value">{activity?.programNameForEducationPreparation || '-'}</div>
            </Col>
          </Row>

          {activity?.programNameForEducationPreparation === 'Other' && (
            <>
            <Row className="g-3 mb-3">
              <Col md={12} className="px-1">
                <div className="gm-summary-field-label">Program Name *</div>
                <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {activity?.programNameForEducationPreparationSpecify || '-'}
                </div>
                <div className="gm-summary-field-label text-end">
                  {activity?.programNameForEducationPreparationSpecify?.length || 0}/30 characters
                </div>
              </Col>
            </Row>
            </>
          )}
          </>
      )}
      {activity?.categoryUC === 'Volunteer/Community Service' && (
        <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Volunteer/Community Service</div>
              <div className="gm-summary-field-label">What's the name of the organization, program, school or group you volunteered for?*</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.organizationVolunteeredFor || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.organizationVolunteeredFor?.length || 0}/60 characters
              </div>
            </Col>
            <Col md={12} className="px-1">
              <div className="gm-summary-field-label">Please describe the organization, program, school or group. *</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.describeOrganization || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.describeOrganization?.length || 0}/250 characters
              </div>
            </Col>
          </Row>
        </>
      )}
      {activity?.categoryUC === 'Work Experience' && (
        <>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className='mb-2 fs-75'>Based on Work Experience</div>
              <div className="gm-summary-field-label">Where did you work*?</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.workExperience_whereDidYouWork || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.workExperience_whereDidYouWork?.length || 0}/60 characters
              </div>
            </Col>
          </Row>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className="gm-summary-field-label">Please briefly describe the company or organization where you worked. *</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.describeCompany || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.describeCompany?.length || 0}/250 characters
              </div>
            </Col>
          </Row>
          <Row className="g-3 mb-3">
            <Col md={12} className="px-1">
              <div className="gm-summary-field-label">What was your job title/position*</div>
              <div className="gm-summary-field-value" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {activity?.workExperience_jobTitle || '-'}
              </div>
              <div className="gm-summary-field-label text-end">
                {activity?.workExperience_jobTitle?.length || 0}/60 characters
              </div>
            </Col>
          </Row>

          <Row className="g-3 mb-3">
            <div className="gm-summary-field-label">When did you work at this job? *</div>
            <div className="text-dark fs-7">
                We'd like to know when you worked at this job and the number of hours per week
                you worked. It's ok to estimate, but try to be as accurate as possible. If you
                worked during the summer, select the grade year before that summer.
            </div>
          </Row>
          <Card className="bg-body my-1 p-2">
          <div className="mt-2 mb-3" key={'9th'}>
            <Row>
              <Col md={6} className="px-1">
                <CheckboxContent key={index} col={12} label={'9th Grade'} values={activity?.workExperience_workWhenNinthGrade} />
              </Col>
            </Row>

            {activity?.workExperience_workWhenNinthGrade && (
              <Row>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={12} label={'School Year'} values={activity?.workExperience_ninthGradeSchoolYear} />
                  {activity?.workExperience_ninthGradeSchoolYear && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_ninthGradeSchoolYearHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={6} label={'Summer'} values={activity?.workExperience_ninthGradeSummer} />
                  {activity?.workExperience_ninthGradeSchoolYear && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_ninthGradeSummerHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
              </Row>
            )}
          </div>

          <div className="my-3" key={'10th'}>
            <Row>
              <Col md={6} className="px-1">
                <CheckboxContent key={index} col={12} label={'10th Grade'} values={activity?.workExperience_workWhenTenthGrade} />
              </Col>
            </Row>

            {activity?.workExperience_workWhenTenthGrade && (
              <Row>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={12} label={'School Year'} values={activity?.workExperience_tenthGradeSchoolYear} />
                  {activity?.workExperience_tenthGradeSchoolYear && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_tenthGradeSchoolYearHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={6} label={'Summer'} values={activity?.workExperience_tenthGradeSummer} />
                  {activity?.workExperience_tenthGradeSummer && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_tenthGradeSummerHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
              </Row>
            )}
          </div>

          <div className="my-3" key={'11th'}>
            <Row>
              <Col md={6} className="px-1">
                <CheckboxContent key={index} col={12} label={'11th Grade'} values={activity?.workExperience_workWhenEleventhGrade} />
              </Col>
            </Row>

            {activity?.workExperience_workWhenEleventhGrade && (
              <Row>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={12} label={'School Year'} values={activity?.workExperience_eleventhGradeSchoolYear} />
                  {activity?.workExperience_eleventhGradeSchoolYear && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_eleventhGradeSchoolYearHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={6} label={'Summer'} values={activity?.workExperience_eleventhGradeSummer} />
                  {activity?.workExperience_eleventhGradeSummer && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_eleventhGradeSummerHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
              </Row>
            )}
          </div>

          <div className="my-3" key={'12th'}>
            <Row>
              <Col md={6} className="px-1">
                <CheckboxContent key={index} col={12} label={'12th Grade'} values={activity?.workExperience_workWhenTwelfthGrade} />
              </Col>
            </Row>

            {activity?.workExperience_workWhenTwelfthGrade && (
              <Row>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={12} label={'School Year'} values={activity?.workExperience_twelfthGradeSchoolYear} />
                  {activity?.workExperience_twelfthGradeSchoolYear && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_twelfthGradeSchoolYearHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
                <Col md={6} className="px-1">
                  <CheckboxContent key={index} col={6} label={'Summer'} values={activity?.workExperience_twelfthGradeSummer} />
                  {activity?.workExperience_twelfthGradeSummer && (
                    <Col md={12} className="px-1">
                      <div className="gm-summary-field-label">Hours Per week</div>
                      <div className="gm-summary-field-value">{activity?.workExperience_twelfthGradeSummerHoursPerWeek || '-'}</div>
                    </Col>
                  )}
                </Col>
              </Row>
            )}
          </div>

          <div className="my-3" key={'after_12th'}>
            <Row>
              <Col md={6} className="px-1">
                <CheckboxContent key={index} col={12} label={'After 12th'} values={activity?.workExperience_workAfterTwelfthGrade} />
              </Col>
            </Row>

            {activity?.workExperience_workAfterTwelfthGrade && (
              <Row>
                <Col md={6} className="px-1">
                    <div className="gm-summary-field-label">Number of Years *</div>
                    <div className="gm-summary-field-value">{activity?.workExperience_afterTwelfthGradeSummerYear || '-'}</div>
                </Col>
                <Col md={6} className="px-1">
                    <div className="gm-summary-field-label">Number of Months *</div>
                    <div className="gm-summary-field-value">{activity?.workExperience_afterTwelfthGradeSummerMonth || '-'}</div>
                </Col>
              </Row>
            )}
          </div>
          </Card>

          <Row className="g-3 my-3">
            <Col md={12} className="px-1">
              <div className="gm-summary-field-label">Do you still work at this job? *</div>
              <div className="gm-summary-field-value">
                {formatBooleanToYesNo(activity?.isStillWork)}
              </div>
            </Col>
          </Row>
 
          <Row className="g-3 mb-3">
            <Col sx={12} md={6} className="px-1">
              <div className="gm-summary-field-label">Start date</div>
              <div className="gm-summary-field-value">{activity?.startDate || '-'}</div>
            </Col>

            {!formatBoolean(activity?.isStillWork) && (
              <Col sx={12} md={6} className="px-1">
                <div className="gm-summary-field-label">End date</div>
                <div className="gm-summary-field-value">{activity?.endDate || '-'}</div>
              </Col>
            )}
          </Row>
        </>
      )}


      
      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">Please describe this activity, including what you accomplished and any recognition you received, etc.</div>
          <div
            className="gm-summary-field-value"
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {activity?.describeActivity || '-'}
          </div>
          <div className="gm-summary-field-label text-end">
            {activity?.describeActivity?.length || 0}/150 characters
          </div>
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">{labelWhatDoYouDo.label}</div>
          <div
            className="gm-summary-field-value"
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {activity?.whatDidYouDo || '-'}
          </div>
          <div className="gm-summary-field-label text-end">
            {activity?.whatDidYouDo?.length || 0}/350 characters
          </div>
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">
            Did you have a specific position or leadership role?
          </div>
          <div className="gm-summary-field-value">
            {formatBooleanToYesNo(activity?.isInvolvedLeadershipRole) || '-'}
          </div>
        </Col>
      </Row>
      {(activity?.isInvolvedLeadershipRole === true ||
        activity?.isInvolvedLeadershipRole === 'true') && (
        <Row className="g-3 mb-3">
          <Col md={12} className="px-1">
            <div className="gm-summary-field-label">What was your role?</div>
            <div
              className="gm-summary-field-value"
              style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
            >
              {activity?.positionDescription || '-'}
            </div>
            <div className="gm-summary-field-label text-end">
              {activity?.positionDescription?.length || 0}/50 characters
            </div>
          </Col>
        </Row>
      )}


      {!(activity?.categoryUC === 'Volunteer/Community Service' ||
         activity?.categoryUC === 'Work Experience') && (
          <>
            <Row className="g-3 mb-3">
              <Col md={12} className="px-1">
                <div className="gm-summary-field-label">Organization Name*</div>
                <div
                  className="gm-summary-field-value"
                  style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                  {activity?.programName || '-'}
                </div>
                <div className="gm-summary-field-label text-end">
                  {activity?.programName?.length || 0}/100 characters
                </div>
              </Col>
            </Row>
          </>
      )}

      {/* Participation grade levels* */}
      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">Participation grade levels*</div>
          <div className="row">
            {[9, 10, 11, 12].map((grade) => {
              const key = `isGrade${grade}ParticipationLevels`;
              const isChecked = !!activity?.[key];
              return (
                <div key={grade} className="col-md-2">
                  <CheckboxContent label={`${grade}`} values={isChecked} />
                </div>
              );
             })}

            {/* Post-graduate (can select mulitple) */}
            <div className="col-md-4">
              <div className="px-1 my-1">
                <CheckboxInput
                  name={`Post-graduate_${index}` }
                  readOnly
                  label={<span className="mt-1 text-field-dark fs-base">Post-graduate <br/>(can select mulitple)</span>}
                  values={activity?.isPostGraduateParticipationLevels}
                />
              </div>
            </div>

          </div>
        </Col>
      </Row>


      {/* Are you currently participating... */}
      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">
            Are you currently participating in this activity or experience?
          </div>
          <div className="gm-summary-field-value">
            {formatBooleanToYesNo(activity?.isCurrentlyParticipatingActivity)}
          </div>
        </Col>
      </Row>

      {/* Timing of Participation* */}
      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">Timing of Participation*</div>
          <Row className="g-3 mb-3">
            {[
              { label: 'During school year', key: 'timmingOfParticipation_duringYear' },
              { label: 'During school break', key: 'timmingOfParticipation_duringBreak' },
              { label: 'All year', key: 'timmingOfParticipation_allYear' },
            ].map((item, idx) => {
              const isChecked = !!activity?.[item.key];
              return (
                <Col md={12} className="px-1" key={item.key}>
                  <div className="gm-summary-field-value">
                    <span
                      style={{
                        marginRight: '.75rem',
                        fontSize: '1.125rem',
                        color: isChecked ? '#1890ff' : '#d9d9d9',
                        fontWeight: isChecked ? 'bold' : 'normal',
                      }}
                    >
                      {isChecked ? '✓' : '○'}
                    </span>
                    {item.label}
                  </div>
                </Col>
              );
            })}
          </Row>          
        </Col>
      </Row>

      {/* Hours per Week*, Weeks per Year* */}
      <Row className="g-3 mb-3">
        <Col md={6} className="px-1">
          <div className="gm-summary-field-label">Hours per Week*</div>
          <div className="gm-summary-field-value">{activity?.hoursPerWeek || '-'}</div>
        </Col>
        <Col md={6} className="px-1">
          <div className="gm-summary-field-label">Weeks per Year*</div>
          <div className="gm-summary-field-value">{activity?.weeksPerYear || '-'}</div>
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">
            I intend to participate in a similar activity in college.*
          </div>
          <div className="gm-summary-field-value">
            {formatBooleanToYesNo(activity?.isIntendParticipateSimilarActivity)}
          </div>
        </Col>
      </Row>

      {/* UC App, Common App */}
      <Row className="g-3 mb-3">
        <Col md={12} className="px-1">
          <div className="gm-summary-field-label">
            Select the applications you would like to include this activity on. *See App Notes above for
            activity limits
          </div>
          <Row className="g-3 mb-3">
            {[
              { label: 'UC App', key: 'isIncludeIntoUCApp' },
              { label: 'Common App', key: 'isIncludeIntoCommonApp' },
            ].map((item, idx) => {
              const isChecked = !!activity?.[item.key];
              return (
                <Col md={6} className="px-1" key={item.key}>
                  <div className="gm-summary-field-value">
                    <span
                      style={{
                        marginRight: '.75rem',
                        fontSize: '1.125rem',
                        color: isChecked ? '#1890ff' : '#d9d9d9',
                        fontWeight: isChecked ? 'bold' : 'normal',
                      }}
                    >
                      {isChecked ? '✓' : '○'}
                    </span>
                    {item.label}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>

    </CardConfig>
  );
};

interface Props {
  data: any;
  startIndex: number;
  total: number;
  expandAll?: boolean;
  handleExpandActive?: (value: any) => void;
  showModal: boolean;
  closeModal: () => void;
  dataCheck?: any;
}

const ActivitySum = ({
  data,
  startIndex,
  total,
  expandAll,
  handleExpandActive,
  showModal,
  closeModal,
  dataCheck,
}: Props) => {
  let showEarning = data.filter((i: any) => i?.categoryUC === 'Work Experience');
  const handleClose = () => closeModal();

  return (
    <div className="gm-summary-section">
      {data &&
        (data || []).map((item: any, index: number) => (
          <ActivityItem
            expandAll={expandAll}
            handleExpandActive={handleExpandActive}
            activity={item}
            key={index}
            index={index + 1 + startIndex + '/' + total}
          />
        ))}

      {!!showEarning.length && (
        <>
          <div className="gm-summary-section-title" style={{ marginTop: 24 }}>
            Earnings Usage
          </div>
          <div className="gm-summary-field-label" style={{ marginBottom: 8 }}>
            Please tell us how you've used your earnings from all of the jobs you've listed. This
            information will NOT be used to determine financial aid — rather, it gives us more
            context about you and your experiences.
          </div>
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">
                How have you used or will you use your earnings?
              </div>
              <div className="gm-summary-field-value">
                {showEarning[0]?.howHaveYouUsedYourEarnings || '-'}
              </div>
            </div>
          </div>
        </>
      )}
      {getUserRole() === USER_ROLE.student && (
        <ModalCheckActivitiesFields
          show={showModal}
          onClose={handleClose}
          data={{ ...dataCheck, startIndex }}
          page="activities"
        />
      )}
    </div>
  );
};

export default ActivitySum;
